import { LightningElement, api, wire } from "lwc";
import { p as purify$1 } from "tds/chunk_purify.es";
import { EffectAdapter } from "common/effectAdapter";

const purify = purify$1(window);

// https://github.com/cure53/DOMPurify/issues/317#issuecomment-728100494
purify.addHook("afterSanitizeAttributes", (node) => {
  // set all elements owning target to target=_blank
  if (node.hasAttribute("target")) {
    node.setAttribute("target", "_blank");
    const prevRel = `${(node.getAttribute("rel") || "")
      .replace("noopener", "")
      .trim()}`;
    const rel = prevRel ? `noopener ${prevRel}` : "noopener";
    node.setAttribute("rel", rel);
  }
});
const defaultOptions = {
  ADD_ATTR: ["target"],
  FORBID_TAGS: ["style"],
};
class sanitizedHtml extends LightningElement {
  @api html = "";
  @api config = defaultOptions;
  node = document.createElement("span");
  get sanitizedHtml() {
    return purify.sanitize(this.html, this.config);
  }
  @wire(EffectAdapter, {
    html: "$html",
  })
  onHtml() {
    this.node.innerHTML = this.sanitizedHtml;
  }
  connectedCallback() {
    this.node.innerHTML = this.sanitizedHtml;
    this.template.host.append(this.node);
  }
}

export default sanitizedHtml;
